import { motion } from "framer-motion";

/**
 * Elegant scroll reveal: fades and lifts children into view once.
 */
export const Reveal = ({ children, delay = 0, y = 30, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

/**
 * Small uppercase eyebrow label with a leading rule.
 */
export const SectionLabel = ({ children, testId }) => (
  <div className="flex items-center gap-3" data-testid={testId}>
    <span className="h-px w-8 bg-sa-bronze" />
    <span className="font-body text-xs sm:text-sm uppercase tracking-[0.22em] font-semibold text-sa-bronze">
      {children}
    </span>
  </div>
);

export default Reveal;
